import React from "react"
import "./styles.scss"

export const Home: React.FC = () => {
	setTimeout(()=>{
		window.location.href="http://signman.jp/app"
	},5000)
	return <div>5秒後にリダイレクトします...</div>
}

export default Home